//src/pages/Authentication/components/OrDivider.js
import React from "react";

const OrDivider = () => {
  return (
    <div style={styles.container}>
      <div style={styles.line}></div>
      <span style={styles.text}>OR</span>
      <div style={styles.line}></div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    margin: "16px 0",
  },
  line: {
    flex: 1,
    height: "1px",
    backgroundColor: "#dbdbdb",
  },
  text: {
    margin: "0 10px",
    fontSize: "12px",
    fontWeight: "400",
    color: "#8e8e8e",
  },
};

export default OrDivider;